/* eslint-disable jsx-a11y/alt-text */
import * as React from "react";
import { styled } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, Outlet } from "react-router-dom";
import Logo from "../../assets/image/logo.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AiOutlineTranslation, AiTwotoneDashboard } from "react-icons/ai";
import { FaTrashRestore, FaUser } from "react-icons/fa";
import { IoIosSettings } from "react-icons/io";
import { getAdminDetailsAPI } from "../../api/auth";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const settings = [
  {
    id: "profile",
    name: "Profile",
    url: "/profile",
  },
  {
    id: "account",
    name: "Account",
    url: "/account",
  },
  {
    id: "dashboard",
    name: "Dashboard",
    url: "/",
  },
  {
    id: "logout",
    name: "Logout",
    url: "/sign-in",
  },
];

export default function MiniDrawer({ children }) {
  const [admin, setAdmin] = React.useState("");

  React.useEffect(() => {
    const getAdminData = async () => {
      const res = await getAdminDetailsAPI();
      const data = res?.data?.details;
      setAdmin(data);
    };
    getAdminData();
  }, []);

  const pages = [
    {
      id: "dashboard",
      icon: <AiTwotoneDashboard />,
      name: "Dashboard",
      url: "/",
    },
    {
      id: "manage_user",
      icon: <FaUser />,
      name: "Manage User",
      url: "/manage-user",
    },
    {
      id: "setting",
      icon: <IoIosSettings />,
      name: "Setting",
      url: "/setting",
    },
    {
      id: "translation",
      icon: <AiOutlineTranslation />,
      name: "Translation",
      url: "/translation",
    },
    {
      id: "restore_user",
      icon: <FaTrashRestore />,
      name: "Restore User",
      url: "/restore-user",
    },
    {
      id: "patrika",
      icon: <FaTrashRestore />,
      name: "Patrika",
      url: "/patrika",
    },
    {
      id: "notification",
      icon: <FaTrashRestore />,
      name: "Notification",
      url: "/notification",
    },
    {
      id: "quotes",
      icon: <FaTrashRestore />,
      name: "Quotes",
      url: "/quotes",
    },
  ];

  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [open, setOpen] = React.useState(true);

  const toggleDrawer = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleCloseUserMenu = (url) => {
    setAnchorElUser(null);
    if (url === "/sign-in") {
      localStorage.removeItem("token");
    }
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open} sx={{ background: "#fff" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <img src={Logo} /> */}
            <IconButton
              color="black"
              aria-label="open drawer"
              onClick={toggleDrawer}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && {}),
              }}
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Box>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              className={styled.loginGrid}
              onClick={handleOpenUserMenu}
            >
              <Box className={styled.profileBox}>
                {/* <img src={ProfileImg} /> */}
              </Box>
              <Typography sx={{ color: "#475569", fontSize: "18px" }}>
                {admin?.name}
              </Typography>
              <ExpandMoreIcon sx={{ color: "#FF0000" }} />
            </Stack>
            <Box>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => handleCloseUserMenu(item.url)}
                  >
                    <Link to={item.url} className="menuLink">
                      <Typography textAlign="center">{item.name}</Typography>
                    </Link>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <img src={Logo} />
        </DrawerHeader>
        <Divider />
        <List sx={{ padding: "5px 10px" }}>
          {pages.map((item, index) => (
            <Link to={item.url} key={index} className="menuLink">
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon sx={{ width: "10px" }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              </ListItem>
            </Link>
          ))}
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {children || <Outlet />}
      </Box>
    </Box>
  );
}
